import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { useCookies } from "react-cookie";
import { graphql, useStaticQuery } from "gatsby"

import useStickyElement from "../../../hooks/useStickyElement"

import { maxD } from "../../../assets/styles/helpers/devices"
import { PageWithoutScroll } from "../../../assets/styles/helpers/modificators"

import { Wrapper, WideWrapper } from "../common/containers"
import { Button } from "../atoms/Button"
import { UnderlinedLink } from "../common/links"
import { HamburgerMenu } from "./Hamburger"
import { Brand } from "./Brand"

import EnglishNavList from "./list/EnglishNavList"
import PolishNavList from "./list/PolishNavList"

import SiteLanguage from "../../../helpers/siteLanguage"

import Icon from "./../../../assets/images/svg/phone.svg"

import LanguageSwitcher from "./../../language-switcher/language-switcher"

const ACFQuery = graphql`
  {
    wp {
      pageHeader {
        en {
          phoneText
          phoneNumber
          contactLink {
            url
            title
            target
          }
        }
        pl {
          phoneTextPl
          phoneNumberPl
          contactLinkPl {
            url
            title
            target
          }
        }
      }
    }
  }
`

const NavInner = styled.nav`
  position: fixed;
  width: 100vw;
  padding: 90px 0 0;
  top: 0;

  z-index: 9980;

  transition: padding 400ms ease;

  &::after {
    display: block;
    position: absolute;
    content: "";

    width: 100%;
    height: 100%;
    z-index: -1;

    top: 0;
    left: 0;
    background-color: #fff;

    transform: translateY(-180px);
    transition: transform 1500ms var(--fancy-cubic-bezier);
    box-shadow: rgb(0 0 0 / 4%) 0px 0px 1px, rgb(0 0 0 / 6%) 0px 0px 2.9px,
      rgb(0 0 0 / 7%) 0px 0px 6.9px, rgb(0 0 0 / 11%) 0px 0px 23px;
  }

  &.sticky {
    padding: 0.5rem 0;
    z-index: 9999;

    &::after {
      transform: translateY(0);
    }

    @media ${maxD.mobileL} {
      padding: 1rem 0;
    }
  }
`

const NavButtons = styled.div`
  display: flex;
  align-items: center;
`

const NavPhone = styled(WideWrapper)`
  position: absolute;
  top: 55px;
  left: 0;
  right: 0;
  padding-right: 0;
  z-index: 9990;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 2rem;
`
const AwardBar = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 45px;
  z-index: 9990;
  display: flex;
  justify-content: end;
  align-items: center;
  background-color: #000;
  background-image: url('https://super-tajny-headless-cms.bravenew.agency/tb-award-bg.png');
  background-size: 100% 100%;
`
const AwardContainer = styled(Wrapper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  @media ${maxD.tablet} {
    justify-content: center;
  }
  p {
    color: #FFF;
    font-size: 12px;
    font-weight: 400;
    @media ${maxD.tablet} {
      display: none;
    }
  }
  img {
    height: 40px;
  }
`

const PhoneLine = styled.p`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
  font-size: 0.85rem;
`

const PhoneIcon = styled(Icon)`
  width: 1rem;
  height: 1rem;
  max-width: 18px;
  max-height: 18px;
  margin-right: 1rem;

  fill: var(--main-green);
`

const Nav = ({ pageContext, data }) => {
  const { isSticky } = useStickyElement()
  const [cookies, setCookie] = useCookies(["language"]);
  const [isMobileActive, toggleNavActivity] = useState(false)
  // let link = ''

  // useEffect(() => {
  //   link = window.location.pathname.slice(0, 4).includes('/pl/') ? "https://bravenew.agency/pl/" : "https://bravenew.agency/"
  // }, [cookies]);

  // I know, this way of doing multilingualism is not the best, but I was doing it 5 hours before leaving the company :c

  const acfData = useStaticQuery(ACFQuery)
  const enData = acfData.wp.pageHeader.en
  const plData = acfData.wp.pageHeader.pl

  let phoneText, phoneNumber, contactLink, link

  if (SiteLanguage() === "en") {
    phoneText = enData.phoneText
    phoneNumber = enData.phoneNumber
    contactLink = enData.contactLink
    link = "https://bravenew.agency/"
  } else {
    phoneText = plData.phoneTextPl
    phoneNumber = plData.phoneNumberPl
    contactLink = plData.contactLinkPl
    link = "https://bravenew.agency/pl/"
  }

  return (
    <>
      {isMobileActive && <PageWithoutScroll />}
      <NavInner className={(isSticky || isMobileActive) && "sticky"}>
        <WideWrapper flex spaceBetween alignItems="c">
          <Brand url={ link } />
          {SiteLanguage() === "en" ? (
            <EnglishNavList isActive={isMobileActive} />
          ) : (
            <PolishNavList isActive={isMobileActive} />
          )}
          <NavButtons>
            {contactLink && (
              <Button
                theme="orange"
                to={contactLink.url}
                target={contactLink.target || "_self"}
                style={{ fontSize: "0.8rem" }}
              >
                {contactLink.title}
              </Button>
            )}
            <HamburgerMenu
              handleHamburgerClick={() => toggleNavActivity(!isMobileActive)}
              isActive={isMobileActive}
            />
          </NavButtons>
        </WideWrapper>
      </NavInner>
      <AwardBar target="_blank" rel="nofollow, noopener" href="https://techbehemoths.com/company/brave-new">
        <AwardContainer>
        {SiteLanguage() === "en" ? (
            <p>Brave New is the 2024 Award-winning company in Poland for its <b>Web Design</b>, <b>Web Development</b> and <b>WordPress services</b></p>
          ) : (
            <p>Brave New zostało nagrodzone za rok 2024 w kategoriach <b>Web Design</b>, <b>Web Development</b> i <b>WordPress services</b></p>
          )}
          
          <img rel="preload" src="https://super-tajny-headless-cms.bravenew.agency/tech-behemoths-1.png" alt="Tech Behemoths awards of 2024"/>
        </AwardContainer>
      </AwardBar>
      <NavPhone relative>
        <LanguageSwitcher pageContext={pageContext} />
        <PhoneLine>
          <PhoneIcon />
          {phoneText} &nbsp;
          {phoneNumber && (
            <UnderlinedLink
              href={`tel:${phoneNumber.replace(" ", "")}`}
              style={{ fontSize: "0.85rem" }}
              as="a"
            >
              {phoneNumber}
            </UnderlinedLink>
          )}
        </PhoneLine>
      </NavPhone>
    </>
  )
}

export default Nav
